// extracted by mini-css-extract-plugin
export default {"courses":"MyCourses_courses__NKf82","courses__h2":"MyCourses_courses__h2__u53eA"};